import { render, staticRenderFns } from "./InfromacioRequerimientoForm.vue?vue&type=template&id=16a43cd8&"
import script from "./InfromacioRequerimientoForm.vue?vue&type=script&lang=ts&"
export * from "./InfromacioRequerimientoForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports